import React from 'react';
import { useEffect } from "react";
import { Helmet } from 'react-helmet';
import "../../../../assets/css/style.css";
import Form from './Form.js'
import PatientReviews from '../../PatientReview.js';

import GetInTouch from '../../GetInTouch.js';
import FollowYt from '../../FollowYt.js'
import ContentWithImages from './ContentWithImages.js'
import DoctorBite from '../../DoctorBite.js';
import Counter from '../../../NumCounter.js';
import Breadcrumb from '../../Breadcrum.js';

export default function Index() {
  useEffect(() => {
    const metaTags = document.getElementsByTagName('meta');
    Array.from(metaTags).forEach((tag) => {
      console.log(tag);
    });
  }, []);
  return (
    <div>
          <Helmet>
            <title>Otitis Externa Treatment in Delhi, India | Ear Infection, Cost, Doctor, Clinic</title>
            <meta name="description" content="Get effective Otitis Externa treatment in Delhi, India. Learn about ear infection causes, procedures, and treatment cost at  MedFirst ENT Centre." />
            <meta name="keywords" content="otitis externa treatment, ear infection , swimmer’s ear care, Acute otitis externa treatment,Chronic otitis externa treatment,Otomize ear spray" />
            <link rel="canonical" href="https://entdelhi.com/otitis-externa/" />
            <meta property="og:title" content="Otitis Externa Treatment in Delhi, India | Ear Infection, Cost, Doctor, Clinic" />
            <meta property="og:description" content="Get effective Otitis Externa treatment in Delhi, India. Learn about ear infection causes, procedures, and treatment cost at  MedFirst ENT Centre." />
            <meta name="robots" content="index, follow" />
            {/* You can add more meta tags as needed */}
          </Helmet>
     <main>
        <Breadcrumb/>
        <Form />    
        <Counter />
         <ContentWithImages/>
         <FollowYt/>
         <DoctorBite/>
         <PatientReviews/>
         
         <GetInTouch/>
      </main>
    </div>
  )
}
